import { render, staticRenderFns } from "./u-header-body-basic.vue?vue&type=template&id=3110b11e&scoped=true&"
import script from "./u-header-body-basic.vue?vue&type=script&lang=js&"
export * from "./u-header-body-basic.vue?vue&type=script&lang=js&"
import style0 from "./u-header-body-basic.vue?vue&type=style&index=0&id=3110b11e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3110b11e",
  null
  
)

export default component.exports